import * as React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setSettings } from "../../store/slice/ProductListingSettings";
import CommonFilterBoxField from "./CommonFilterBoxField";
import {
    applyFilterByMainKeyAndSlug,
    clearFilterByKeyAndSelectionIndex
} from "../../store/slice/ProductListingFilterApplied";

import { useProductStore } from 'src/hooks/product';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import HelperAdobeEvent from 'src/support/HelperAdobeEvent';
import { useSearchParams } from 'react-router-dom';

const TopSearchTable = (props) => {
    const { isBomPLP } = props;
    const [__check] = useAxiosIndicatorCheck    ();
    const list = useSelector((state) => state.entities.ProductListingAPICall.data)
    const filter_box_expanded = useSelector((state) => state.entities.ProductListingSettings.filter_box_expanded)
    const filterBoxSelection = useSelector((state) => state.entities.ProductListingFilterBoxSelection)
    const [{ category_filter_applied_status }, { }, { }, { optionsAvailable }] = useProductStore();
    const dispatch = useDispatch()
    const [load,setLoad] = React.useState(false);
    const [selectedFilter, setSelectedFilter] = React.useState('');
    const LoadFilterBox = (boxSelectorName) => {
        if (filterBoxSelection[boxSelectorName.slug] !== undefined) {
            return <CommonFilterBoxField {...boxSelectorName} onFacetsChange={async (filterVal) => {
                filterVal && setSelectedFilter(filterVal)
            }} />
        }
        return '';
    }
    const filter = useSelector((state) => state.entities.ProductListingFilterApplied)
    const getAppliedFilterStatusByValue = (value) => {
        let slug = 'flagFacets';
        if (filter[slug] !== undefined &&
            filter[slug].selection !== undefined &&
            filter[slug].selection.length
        ) {
            let decision = false;
            filter[slug].selection.map((v, i) => {
                if (v.value === value) {
                    decision = {
                        v, i
                    };
                }
            });
            return decision;
        }
        return false;
    };

    const isFacets =  list?.flagFacets?.flagFacets?.length > 0 ? "filterbox w220" : ""
    const isOpacity =  list?.flagFacets?.flagFacets?.length > 0 ? "loader-wrapper loader-wrapper-fixed" : " loader-wrapper loader-wrapper-fixed loader-opacity"
    const [searchParams] = useSearchParams();
    /**
     * Author : Pankaj 
     * Change : Loader optimization for facets when page load initial
     * Date   : 08 Aug,2023
     */
    React.useEffect(() => {
        if(isFacets !== '' && load === false)
        {
            setLoad(true)
        }   
    },[isFacets])
    React.useEffect(() => {
        if (selectedFilter && filter && filter[selectedFilter?.key]?.selection?.length > 0) {
            setSelectedFilter('')
            filterAppliedEvent();
        }
    }, [list])

    const filterAppliedEvent = () => {
        localStorage.setItem("adobeEventType", "searchFilterEvent");
        let makeFilterArr = filter;
        let filterSlugArr = Object.keys(filter);
        let filterArrName = [];
        filterSlugArr.forEach((sData) => {
            let newArr = makeFilterArr[sData].selection;
            newArr.forEach((data, key) => {
                filterArrName.push(data?.value);
            });
        });
        let filterDetails = {
            searchTerm: searchParams.get("search") || '',
            appliedFilterArr: filterArrName?.join(),
            appliedFltCount: filterArrName.length,
            searchCount: list && list["@odata.count"],
        };
        if (Object.keys(filterDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({ filterDetails });
        }
    }
    return (
        <>
            {/* <SystemAlerts /> */}
            <div className="search-page-tab">
                {/* Nav tabs */}
                {/* Tab panes */}
                <div className="tab-content">
                    {(__check(['PRODUCT_FACETS_API_CALL']).status) &&
                        <div className="plp-filter-loader">
                            <div className={`loader-wrapper loader-wrapper-fixed ${(!load) ? ' loader-opacity' : ''}`}>
                                <div className="loading-icon clearfix ">
                                    <div className="ball1"></div>
                                    <div className="ball2"></div>
                                    <div className="ball3"></div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="tab-pane active" id="tab1">
                        <div className="search-filter-wrapper">
                            <div className="container-fluid maxw100">
                                <div className="bs5 row g-20 position-relative search-filter-wrapper-inner">
                                    <div className="col-auto mb-3">
                                        <div className={filter_box_expanded  ? `${isFacets} expanded` : isFacets }>
                                            <div className={load ? "filterbox-body" : "filterbox-body d-none"}>
                                                {list?.flagFacets !== undefined && 
                                                    list.flagFacets?.flagFacets?.length > 0 &&
                                                    list.flagFacets.flagFacets.map((v,i) => (
                                                        <div className="form-check" key={i}>
                                                            <input type="checkbox"
                                                                checked={getAppliedFilterStatusByValue(v.main_label)}
                                                                onChange={() => {
                                                                    let d = getAppliedFilterStatusByValue(v.main_label);
                                                                    if (!d) {
                                                                        setSelectedFilter({ key: 'flagFacets', value: v.value });
                                                                        dispatch(applyFilterByMainKeyAndSlug({
                                                                            key: 'flagFacets',
                                                                            main_label: 'Only Show',
                                                                            value: v.main_label,
                                                                            hidden_payload: {
                                                                                key: v.key,
                                                                                value: v.value
                                                                            },
                                                                        }))
                                                                    } else {
                                                                        dispatch(clearFilterByKeyAndSelectionIndex({
                                                                            key: 'flagFacets',
                                                                            selectionIndex: d.i,
                                                                        }))
                                                                    }
                                                                }}
                                                                disabled={v.count < 1}
                                                                className="form-check-input"
                                                                id={v.main_label} name={v.slug} />
                                                            <label disabled={v.count < 1} className="form-check-label"
                                                                htmlFor={v.main_label}>{v.main_label}<span
                                                                    className="filter-count"> ({v.count})</span></label>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {list && list['@search.facets'] !== undefined &&
                                        Object.entries(list['@search.facets']).length > 0 &&
                                        Object.entries(list['@search.facets']).map((v, i) => (
                                            <React.Fragment key={i}>
                                                {v[1] !== undefined &&
                                                    v[1][v[1].slug].length > 0 &&
                                                    <React.Fragment key={i}>
                                                        {LoadFilterBox(v[1])}
                                                    </React.Fragment>
                                                }
                                            </React.Fragment>
                                        ))
                                    }
                                    <div className="col-auto mb-3">
                                        <div
                                            className={category_filter_applied_status === false ? 'filterbox d-none' : (filter_box_expanded ? 'filterbox add-search-filter expanded' : 'filterbox add-search-filter')}>
                                            <button
                                                style={{
                                                    color: '#ffffff !important'
                                                }}
                                                className="white-bg bs5 btn btn-primary"
                                                onClick={() => {
                                                    props.openFilterBoxSettings()
                                                }}
                                            >Add Filters
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className={filter_box_expanded ? 'filter-expander expanded' : 'filter-expander'}
                                    onClick={() => {
                                        dispatch(setSettings({
                                            key: 'filter_box_expanded',
                                            value: !filter_box_expanded,
                                        }));
                                    }}
                                    
                                    id="adv_fltrs_sec_hdr"><span id="breadCrumb"
                                        className="fa fa-angle-double-down" /><span
                                        className="fa fa-angle-double-up" /></div>
                            </div>
                        </div>
                    </div>
                    {filter_box_expanded}
                    <div className="tab-pane container fade" id="tab2">
                            <span className='filter-records px-0'>Showing 2 content results for "bat"</span>
                    </div>
                    <div className="tab-pane container fade" id="tab3">
                            <span className='filter-records px-0'>Showing 1,256 content results for "bat"</span>
                    </div>
                    <div className="tab-pane container fade" id="tab4">
                            <span className='filter-records px-0'>Showing 1-20 of 685 document results for "bat"</span>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TopSearchTable;